import { NextSeo } from 'next-seo';
import PageBanner from '../components/pageBanner';
import { TechnologyStackItem } from '../components/technology-stack';
import React from 'react';
import CallToActions from '@apps/components/ico-landing/CallToActions';

const TechnologyStack = () => {
  const metaTitle = "Technology Stack - Alchemis";
  const metaImg = `/images/meta/technology-stack.png`;
  return (
    <div className="bg-[#101436]">
      <NextSeo
        title={metaTitle}
        openGraph={{
          title: `${metaTitle}`,
          images: [
            {
              url: `${metaImg}`,
            }
          ]
        }}
      />
      <PageBanner text="Technology Stack" image={'/images/gradient_dark.jpeg'} />
      <TechnologyStackItem/>
      <CallToActions
        title={"Interested in creating a Web3 project?"}
        background={"/images/cta.png"}
        description={"Contact us today to see how our Web3 solution will help you realise your full business potential!"}
        btnText={"Start Now"}
        link={"/contact"}
      />
    </div>
  )
}

export default TechnologyStack;
